"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogVariants = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("./common/buttons/Button"));
var tick_icon_dark_svg_1 = __importDefault(require("res/img/tick-icon-dark.svg"));
var close_icon_svg_1 = __importDefault(require("res/img/close-icon.svg"));
var DialogVariants;
(function (DialogVariants) {
    DialogVariants["CONFIRMATION"] = "confirmation";
    DialogVariants["ALERT"] = "alert";
})(DialogVariants = exports.DialogVariants || (exports.DialogVariants = {}));
var Dialog = function (_a) {
    var variant = _a.variant, title = _a.title, description = _a.description, onSubmit = _a.onSubmit, open = _a.open, onClose = _a.onClose;
    return (react_1.default.createElement("div", { className: "dialog", "data-open": open, "data-close": "true" },
        react_1.default.createElement("div", { className: "dialog__content" },
            react_1.default.createElement("div", { className: "dialog__title" }, title),
            react_1.default.createElement("div", { className: "dialog__description" },
                react_1.default.createElement("p", null, description)),
            react_1.default.createElement("div", { className: "actions" },
                react_1.default.createElement("div", { className: "flex flex-row flex-center" },
                    react_1.default.createElement("div", { className: "actions__buttons flex flex-row flex-center" },
                        react_1.default.createElement(Button_1.default, { title: variant === DialogVariants.ALERT && "OK" || "Yes", icon: react_1.default.createElement("img", { src: tick_icon_dark_svg_1.default, alt: 'OK' }), onClick: onSubmit }, variant === DialogVariants.ALERT && "OK" || "Yes"),
                        variant !== DialogVariants.ALERT &&
                            react_1.default.createElement(Button_1.default, { title: 'No', icon: react_1.default.createElement("img", { src: close_icon_svg_1.default, alt: 'No' }), onClick: onClose }, "No")))))));
};
exports.default = Dialog;
